import { myCompanyTeams } from './types';

export const requestMyCompanyTeams = () => ({
  type: myCompanyTeams.request,
});

export const requestMyCompanyTeamsSuccess = (response) => ({
  type: myCompanyTeams.success,
  response,
});

export const requestMyCompanyTeamsFailure = (error) => ({
  type: myCompanyTeams.failure,
  error,
});
